import { AlertBar } from '@packages/ui/shared';
import { Button, Typography } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface CidCvnStartCaseModalProps {
    alertBarMessage: { message: string };
    isLoading: boolean;
    onCloseAlertBar: () => void;
    onHide: () => void;
    onStart: () => void;
    show: boolean;
}

const useStyles = createUseStyles({
    modal: {
        minWidth: '528px',
    },
});

export function CidCvnStartCaseModal({
    alertBarMessage,
    isLoading,
    onCloseAlertBar,
    onHide,
    onStart,
    show,
}: CidCvnStartCaseModalProps) {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Modal
            backdrop={isLoading ? 'static' : true}
            centered
            contentClassName={classes.modal}
            onHide={onHide}
            show={show}
        >
            <Modal.Header>
                <Modal.Title>{t('cidCvnCheck:createCaseModal.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AlertBar
                    show={!!alertBarMessage.message}
                    error={true}
                    onClose={onCloseAlertBar}
                    style={{ marginBottom: 24 }}
                >
                    <Typography>{alertBarMessage.message}</Typography>
                </AlertBar>
                <Typography>{t('cidCvnCheck:createCaseModal.description')}</Typography>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="ghost-blue" onPress={onHide} disabled={isLoading} style={{ marginRight: 2 }}>
                    {t('buttons:cancel')}
                </Button>
                <Button
                    variant="primary"
                    isLoading={isLoading}
                    disabled={isLoading || !!alertBarMessage.message}
                    onPress={onStart}
                >
                    {t('buttons:start')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
